/*eslint-disable*/
import React, {useState, useEffect, Fragment} from "react";
import {Link, useLocation} from "react-router-dom";
import {useForm} from "react-hook-form";

import APIClient from "../client";
import config from "../config.js"
import TableChart from "../components/Charts/TableChart.js";
import AuthNavbar from "../components/Navbars/AuthNavbar.js";
import CardError from "../components/Cards/CardError.js";

import '../assets/styles/App.css';
import '../assets/styles/tailwind.css';
import "@fontsource/montserrat";


const client = new APIClient(config);


export default function AdminUserPermissions() {
    const {
        register: registerUser,
        formState: {errors},
        handleSubmit,
    } = useForm({
            mode: "onBlur",
        }
    );

    const {
        register: registerPermission,
        formState: {errors: errors2},
        handleSubmit: handleSubmit2,
    } = useForm({
        mode: "onBlur",
    });

    const [columnData, setColumnData] = useState(null);
    const [dropDowndata, setDropDown] = useState(null);
    const [showWarning, setShowWarning] = useState(false)


    const [userId, setUserId] = useState(null);
    const [userEmail, setUserEmail] = useState(null);
    const [userData, setUserData] = useState(null);
    const [permissionData, setUserPermissionData] = useState(null);

    const [status, setStatus] = useState();

    const [userStatus, setUserStatus] = useState(null);
    const [userError, setUserError] = useState(null);
    const [permissionStatus, setPermissionStatus] = useState(null);
    const [permissionError, setPermissionError] = useState(null);
    const [permissionDeleteStatus, setPermissionDeleteStatus] = useState(null);
    const [permissionDeleteError, setPermissionDeleteError] = useState(null);
    const [syncStatus, setSyncStatus] = useState(null);
    const [syncError, setSyncError] = useState(null);


    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState();

    const {state} = useLocation();

    useEffect(() => {

        if (state != null) {
            setUserId(state[0]["user_id"]);
            setUserEmail(state[0]["email"]);
            fetchUserInformation();
            fetchDropdownData();
        } else {
            setMessage("Not allowed.");
        }
    }, []);

    const fetchUserInformation = () => {
        Promise.all([
            client.getUser(state[0]["email"]),
            client.getUserPermission(state[0]["user_id"])
        ])
            .then(([resUser, resPermission]) =>
                Promise.all([resUser, resPermission])
            )
            .then(([dataUser, dataPermission]) => {
                if ([dataUser, dataPermission]) {
                    setUserData(dataUser['data']['data']);
                    setUserPermissionData(dataPermission['data']['data']);

                    const columns = [
                        {
                            key: "action",
                            text: "Action",
                            className: "action",
                            width: 100,
                            align: "left",
                            sortable: false,
                            cell: (record) => {
                                return (
                                    <Fragment>
                                        <button
                                            className="get-started text-blue rounded py-1 px-7 bg-yellow"
                                            onClick={() => {
                                                onDeletePermission(record);
                                            }
                                            }
                                        >
                                            &nbsp;
                                            <i className="fa fa-eraser" aria-hidden="true"></i>
                                            &nbsp; Delete &nbsp;
                                        </button>
                                    </Fragment>
                                );
                            },
                        },
                        {
                            name: "view_unmasked",
                            sortable: true,
                            selector: (row) => row.view_unmasked.toString(),
                        },
                        {
                            name: "display_name",
                            sortable: true,
                            selector: (row) => row.funder_detail.display_name,
                        },
                        {
                            name: "masked_name",
                            sortable: true,
                            selector: (row) => row.funder_detail.masked_name,
                        },
                        {
                            name: "masked_funder_name",
                            sortable: true,
                            selector: (row) => row.funder_detail.masked_funder_name,
                        },
                        {
                            name: "permission_add_date",
                            sortable: true,
                            selector: (row) => row.created_at,
                        },
                        {
                            name: "funder_id",
                            omit: true,
                            selector: (row) => row.funder_detail.id,
                        },
                        {
                            name: "user_id",
                            omit: true,
                            selector: (row) => row.user.id,
                        },
                    ];

                    setColumnData(columns);

                    setStatus(200);
                    setLoading(false);
                } else {
                    setStatus(500);
                    setLoading(false);
                }
            })
            .catch(function (error) {
                setStatus(500);
                setMessage("Looks like we cant show this at the moment.");
                setLoading(false);

            })
    };

    const fetchDropdownData = () => {
        client.getFunderNames().then((data) => {
            setDropDown(data['data']['data']);
        });
    };

    const onSubmitUser = (event) => {

        client.updateUser(event)
            .then(() => {
                setUserStatus("User Updated.");
                setUserError(null);
            })
            .catch((err) => {
                setUserStatus(null);
                setUserError(err);
            });
    };

    const onSubmitPermission = (event) => {
        client.addUserPermission(event).then(() => {
            setPermissionStatus("User Permission added.");
            setPermissionError(null);
            fetchUserInformation();
        })
            .catch((err) => {
                setPermissionError(err);
                setPermissionStatus(null);
            });
    };

    const onDeletePermission = (event) => {
        client.removeUserPermission(event.id).then(() => {
            setPermissionDeleteStatus("User Permission removed.");
            setPermissionDeleteError(null);
            fetchUserInformation();
        })
            .catch((err) => {
                setPermissionDeleteError(err);
                setPermissionDeleteStatus(null);
            });
    };

    const onSyncUser = (id) => {
        console.log(userId);
        client.syncUser(userId).then(() => {
            setSyncStatus("User Sync completed.");
            setSyncError(null);
        })
            .catch((err) => {
                setSyncError(err);
                console.log(err);
                setSyncStatus(null);
            });
    };

    const handleSelectChange = (e) => {
        if (e.target.value === 'false') {
            setShowWarning(true);
        } else {
            setShowWarning(false);
        }
    };

    const screenSize = (window.innerWidth >= 912);
    const screenSizeTwo = (window.innerWidth >= 1024);

    document.title = "User Permissions";

    return (
        <>
            <section>
                <AuthNavbar />
            </section>

            <section className="relative grad-1 pb-20">
                <div className="container relative mx-auto pt-12 px-4 w-10/12">

                    {loading && (
                        <div className="text-xl text-yellow font-medium">Loading...</div>
                    )}
                    {message && <CardError message={message}/>}

                    {userData && (

                        <>


                            <div className="container relative mx-auto items-center rounded-lg mt-24 mb-4 px-4">
                                <h2 className="text-36 text-yellow mb-6">User Permissions</h2>
                            </div>

                            <div className="flex flex-wrap mb-0">

                                <div className="relative md:w-6/12 lg:w-6/12 px-4 mb-1">
                                    <div className="relative bg-white-7 w-full rounded-lg p-4 mb-8">

                                        <div className="w-full flex items-center">
                                            <div className="w-3/12">
                                                <div className="relative flex flex-col text-white w-full">
                                                    {/*<FiatGroup className="size-btc-group"/>*/}
                                                    <i className="fa fa-user-circle fa-6" aria-hidden="true"></i>
                                                </div>
                                            </div>
                                            <div className="w-9/12">
                                                <div className="relative flex flex-col w-full px-6">
                                                    <h2 className="text-24-performance text-white">User Detail</h2>
                                                </div>
                                            </div>
                                        </div>

                                        <hr className="mb-4 bigHr"></hr>

                                        <form onSubmit={handleSubmit(onSubmitUser)}>

                                            <table className="bg-transparent even:bg-blue-950">
                                                <tbody>
                                                <tr>
                                                    <td className="pb-4 text-14-400 text-white">FIRST NAME</td>
                                                    <td><input
                                                        type="text"
                                                        className="relative text-blue-v-dark m-1 block w-full flex-auto rounded-e border border-solid border-neutral-200 bg-transparent bg-clip-padding px-2 py-[0.17rem] text-sm font-normal leading-[1.5] text-surface outline-none transition duration-200 ease-in-out placeholder:text-neutral-500 focus:z-[3] focus:border-primary focus:shadow-inset focus:outline-none motion-reduce:transition-none dark:border-white/10 dark:text-white dark:placeholder:text-neutral-200 dark:autofill:shadow-autofill dark:focus:border-primary"
                                                        name="userFirstName"
                                                        {...registerUser("userFirstName")}
                                                        defaultValue={userData.first_name}
                                                    >
                                                    </input></td>
                                                </tr>
                                                <tr className="bg-transparent">
                                                    <td className="pb-4 text-14-400 text-white">LAST NAME</td>
                                                    <td><input
                                                        type="text"
                                                        className="relative text-blue-v-dark m-1 block w-full flex-auto rounded-e border border-solid border-neutral-200 bg-transparent bg-clip-padding px-2 py-[0.17rem] text-sm font-normal leading-[1.5] text-surface outline-none transition duration-200 ease-in-out placeholder:text-neutral-500 focus:z-[3] focus:border-primary focus:shadow-inset focus:outline-none motion-reduce:transition-none dark:border-white/10 dark:text-white dark:placeholder:text-neutral-200 dark:autofill:shadow-autofill dark:focus:border-primary"
                                                        name="userLastName"
                                                        {...registerUser("userLastName")}
                                                        defaultValue={userData.last_name}
                                                    >
                                                    </input></td>
                                                </tr>
                                                <tr>
                                                    <td className="pb-4 text-14-400 text-white">EMAIL</td>
                                                    <td><input
                                                        type="text"
                                                        className="relative text-blue-v-dark m-1 block w-full flex-auto rounded-e border border-solid border-neutral-200 bg-transparent bg-clip-padding px-2 py-[0.17rem] text-sm font-normal leading-[1.5] text-surface outline-none transition duration-200 ease-in-out placeholder:text-neutral-500 focus:z-[3] focus:border-primary focus:shadow-inset focus:outline-none motion-reduce:transition-none dark:border-white/10 dark:text-white dark:placeholder:text-neutral-200 dark:autofill:shadow-autofill dark:focus:border-primary"
                                                        name="email"
                                                        {...registerUser("email")}
                                                        defaultValue={userData.email}
                                                        readOnly>
                                                    </input></td>
                                                </tr>
                                                <tr>
                                                    <td className="pb-4 text-14-400 text-white">SUPER USER</td>
                                                    <td>
                                                        <select
                                                            className="relative m-1 block w-full flex-auto rounded-e border border-solid border-neutral-200 bg-transparent bg-clip-padding px-3 "
                                                            {...registerUser("userIsSuper")}
                                                            defaultValue={userData.is_superuser}
                                                        >
                                                            <option className="dark:bg-surface-dark" value="true">True
                                                            </option>
                                                            <option className="dark:bg-surface-dark" value="false">False
                                                            </option>
                                                        </select>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="pb-4 text-14-400 text-white">FUND VIEWER</td>
                                                    <td>
                                                        <select
                                                            className="relative m-1 block w-full flex-auto rounded-e border border-solid border-neutral-200 bg-transparent bg-clip-padding px-3 "
                                                            {...registerUser("userIsFundViewer")}
                                                            defaultValue={userData.is_fund_viewer}
                                                        >
                                                            <option className="dark:bg-surface-dark" value="true">True
                                                            </option>
                                                            <option className="dark:bg-surface-dark" value="false">False
                                                            </option>
                                                        </select>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="pb-4 text-14-400 text-white">OPPORTUNITY VIEWER</td>
                                                    <td>
                                                        <select
                                                            className="relative m-1 block w-full flex-auto rounded-e border border-solid border-neutral-200 bg-transparent bg-clip-padding px-3 "
                                                            {...registerUser("userIsOpportunityViewer")}
                                                            defaultValue={userData.is_opportunity_viewer}
                                                        >
                                                            <option className="dark:bg-surface-dark" value="true">True
                                                            </option>
                                                            <option className="dark:bg-surface-dark" value="false">False
                                                            </option>
                                                        </select>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="pb-4 text-14-400 text-white">ACTIVE</td>
                                                    <td>
                                                        <select
                                                            className="relative m-1 block w-full flex-auto rounded-e border border-solid border-neutral-200 bg-transparent bg-clip-padding px-3 "
                                                            {...registerUser("userIsActive", {onChange: handleSelectChange })}
                                                            defaultValue={userData.is_active}
                                                        >
                                                            <option className="dark:bg-surface-dark" value="true">True
                                                            </option>
                                                            <option className="dark:bg-surface-dark"
                                                                    value="false">False
                                                            </option>
                                                        </select>
                                                        {showWarning && (
                                                        <div className="text-red-500 mt-2">
                                                            Warning: This will delete the user from
                                                            Auth0.
                                                        </div>
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><input type="hidden"
                                                               {...registerUser("editUser")}
                                                               value={userData.id}/>
                                                        <input type="hidden"
                                                               {...registerUser("editUserCreated")}
                                                               value={userData.created_at}/>
                                                    </td>
                                                    <td className="text-center">
                                                        <button
                                                            className="bg-yellow text-16-19 text-blue-v-dark py-2 px-12 rounded"
                                                            type="submit"
                                                        >
                                                            <i className="fa fa-address-card" aria-hidden="true"></i>

                                                            &nbsp; Save User &nbsp;
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td>
                                                        {userStatus !== null && (
                                                            <p className="text-yellow text-sm text-center italic">User
                                                                Updated.</p>
                                                        )}

                                                        {userError !== null && (
                                                            <p className="text-red-500 text-center text-sm">Error
                                                                updating User.</p>
                                                        )}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </form>
                                    </div>
                                </div>

                                <div className="relative md:w-6/12 lg:w-6/12 px-4 mb-1">
                                    <div className="relative bg-white-7 w-full rounded-lg p-4 mb-8">
                                        <div className="w-full flex items-center">
                                            <div className="w-3/12">
                                                <div className="relative flex flex-col text-white w-full">
                                                    {/*<FiatGroup className="size-btc-group"/>*/}
                                                    <i className="fa fa-user-circle fa-6" aria-hidden="true"></i>
                                                </div>
                                            </div>
                                            <div className="w-9/12">
                                                <div className="relative flex flex-col w-full px-6">
                                                    <h2 className="text-24-performance text-white">User Permissions</h2>
                                                </div>
                                            </div>
                                        </div>

                                        <hr className="mb-4 bigHr"></hr>

                                        {dropDowndata ? (

                                            <form onSubmit={handleSubmit2(onSubmitPermission)}>
                                                <table>
                                                    <tbody>
                                                    <tr>
                                                        <td className="pb-4 text-14-400 text-white">SELECT PORTFOLIO
                                                        </td>
                                                        <td>
                                                            <select
                                                                className="relative m-1 block w-full flex-auto rounded-e border border-solid border-neutral-200 bg-transparent bg-clip-padding px-3 "
                                                                {...registerPermission("portfolio", {required: true})}
                                                            >
                                                                {dropDowndata.map((e) => <option value={e.id}
                                                                                                 key={e.id}>{e.display_name}</option>)}
                                                            </select>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="pb-4 text-14-400 text-white">CAN VIEW UNMASKED
                                                        </td>
                                                        <td>
                                                            <select
                                                                className="relative m-1 block w-full flex-auto rounded-e border border-solid border-neutral-200 bg-transparent bg-clip-padding px-3 "
                                                                {...registerPermission("view_unmasked", {required: true})}
                                                            >
                                                                <option className="dark:bg-surface-dark"
                                                                        value="true">True
                                                                </option>
                                                                <option className="dark:bg-surface-dark"
                                                                        value="false">False
                                                                </option>
                                                            </select>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><input type="hidden"
                                                                   {...registerPermission("permissionUser")}
                                                                   value={userData.id}/></td>
                                                        <td className="text-center">
                                                            <button
                                                                className="bg-yellow text-16-19 text-blue-v-dark py-2 px-12 rounded"
                                                                type="submit"
                                                            >
                                                                <i className="fa fa-rocket" aria-hidden="true"></i>

                                                                &nbsp; Add Permission &nbsp;
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>
                                                            {permissionStatus !== null && (
                                                                <p className="text-yellow text-sm text-center italic">User
                                                                    Permission Added.</p>
                                                            )}

                                                            {permissionError !== null && (
                                                                <p className="text-red-500 text-center text-sm">Error
                                                                    adding User Permission.</p>
                                                            )}
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>


                                            </form>

                                        ) : (<></>)
                                        }

                                    </div>

                                    <div className="relative bg-white-7 w-full rounded-lg p-4 mb-8">
                                        <div className="w-full flex items-center">
                                            <div className="w-3/12">
                                                <div className="relative flex flex-col text-white w-full">
                                                    <i className="fa fa-user-circle fa-6" aria-hidden="true"></i>
                                                </div>
                                            </div>
                                            <div className="w-9/12">
                                                <div className="relative flex flex-col w-full px-6">
                                                    <h2 className="text-24-performance text-white">Sync Auth0</h2>
                                                </div>
                                            </div>
                                        </div>

                                        <hr className="mb-4 bigHr"></hr>

                                        <div className="relative flex flex-col w-full px-6">

                                            <button
                                                className="bg-yellow text-16-19 text-blue-v-dark py-2 px-12 rounded"
                                                type="button"
                                                onClick={() => onSyncUser(userData.id)}
                                            >
                                                <i className="fa fa-share-alt" aria-hidden="true"></i>

                                                &nbsp; Sync User &nbsp;
                                            </button>

                                        </div>
                                        <div className="relative flex flex-col w-full px-6">
                                            {syncStatus !== null && (
                                                <p className="text-yellow text-sm text-center italic">User
                                                    sync completed.</p>
                                            )}

                                            {syncError !== null && (
                                                <p className="text-red-500 text-center text-sm">Error
                                                    syncing User.</p>
                                            )}

                                        </div>

                                    </div>


                                </div>


                            </div>

                            <div className="px-4 mt-2">
                                <div
                                    className="relative flex w-full flex-col bg-white-7 rounded-lg min-w-0 break-words mb-6">

                                    {permissionDeleteStatus !== null && (
                                        <p className="text-yellow text-center text-sm italic">{permissionDeleteStatus}</p>
                                    )}

                                    {permissionDeleteError ?? (
                                        <p className="text-red text-center text-xs italic">{permissionDeleteError}</p>
                                    )}

                                    <TableChart
                                        columns={columnData}
                                        data={permissionData}
                                        defaultSortFieldId={1}
                                        // selectableRows
                                        // selectableRowsSingle={true}
                                        // onSelectedRowsChange={handleSelection}
                                        dense
                                    />

                                </div>
                            </div>

                        </>


                    )}

                </div>
            </section>


        </>
    );
}

